module.exports = "<svg xmlns=http://www.w3.org/2000/svg viewBox=\"0 0 60 60\"><title>MindFire</title><g id=a275720c-41c9-4bb2-88de-7a4b5b6759b4 data-name=\"Layer 2\"><path d=M55.1,13.58a32.81,32.81,0,0,0-2-2.74C57.89,25.4,40.56,39.32,36.51,42.33l2.81,4.31L23.5,45.05,27.12,28l3.46,5.3C49.49,20.91,49.8,10.82,48.83,6.65a30,30,0,0,0-44.43,39C2.35,32.09,17.83,19.68,21.63,16.86l-2.82-4.31,15.83,1.59L31,31.21l-3.47-5.3C10,37.39,8.48,46.9,9.12,51.54a30,30,0,0,0,46-38Z /></g></svg>";


//////////////////
// WEBPACK FOOTER
// ../~/html-loader!../~/@printos/gazelle/src/mini-apps/app-switcher/icons/da-vinci.svg
// module id = 189
// module chunks = 0